import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { fetchUserInfo } from '../../../redux-flow/actions/users'
import { Link } from 'react-router-dom'
import Navbar from '../../../Components/Navbar'
import Footer from '../../../Components/Footer'
import Container from 'react-bootstrap/Container'
import { Redirect } from 'react-router-dom'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import '../wallet.css'

class InvestimentosWallet extends PureComponent {
    constructor(props) {
    super(props)
    this.state = {

                    // fillBackground: false,
    }}
        render() {

            const {
                            logged,
                        } = this.props
            
            return (
    
                <>
                    <Navbar/>
                    {!logged ? <Redirect to="/login" /> : (
                        <div>
                        <div className="section minhaContaWrapper">
                            <Container>
                                <Row>
                                    <Col md={12}>
                                        <div className="d-flex align-items-end justify-content-between tabTitleWrapper">
                                            <h4 className="pageTitle text-white">Minha conta</h4>
                                            <div className="tabMenu d-flex">
                                                {/* <Link className="tabMenuLink mr-4" to="/meusinvestimentos">Meus Investimentos</Link> */}
                                                <Link className="tabMenuLink tabMenuActive" to="/wallet">{process.env.REACT_APP_NAME} Wallet</Link>
                                                <Link className="tabMenuLink ml-4" to="/minhaconta">Meus Dados</Link>
                                            </div>
                                        </div>
                                        <hr />
                                        
                                    </Col>
                                </Row>

                                <Row>
                                    <label>InvestimentosWallet</label>
                                </Row>
                            </Container>
                        </div>
                        </div>
                        
                    )}
                    <Footer />
                </>
            )
        }
    }

    const mapStateToProps = state => ({
    logged: state.login.logged,
    userid: state.login.userid,
    userLoading: state.users.isLoading,
    userLogged: state.users.userLogged,
})

const mapDispatchToProps = dispatch => ({
    onLoad: id => {
        dispatch(fetchUserInfo(id))
    }
})

    export default connect(mapStateToProps, mapDispatchToProps)(InvestimentosWallet)